import { createModel } from "hox";
import { useState, useEffect } from "react";
import { ISelectOption, ITreeData } from "@src/components/YhFormBox/Types";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@src/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination } from "@src/utils/utils";
import { ISearchPage } from "@src/types/FmsTypes";
import { orgService } from "@src/views/authPortal/base/org/OrgService";
import { rosterService } from "./rosterService";
import { dictService } from "@src/views/authPortal/base/dict/DictService";
import { convertRes2Blob } from "@src/utils/exportFile";

export const baseInfoModel = createModel(function () {
    const [print, setPrint] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<any[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [orgDs, setOrgDs] = useState<ITreeData[]>();
    const [educationalTypeDs, setEducationalTypeDs] = useState<ISelectOption[]>();
    const [certificateTypeDs, setCertificateTypeDs] = useState<ISelectOption[]>();
    const [hukouTypeDs, setHukouTypeDs] = useState<ISelectOption[]>();
    const [baseTypeDs, setBaseTypeDs] = useState<ISelectOption[]>();

    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadDs = async () => {
        const orgds = await orgService.orgTreeDs({});
        const educationalTypes = await dictService.dictItemDs('educational');
        const certificateTypes = await dictService.dictItemDs('Certificate');
        const hukouTypes = await dictService.dictItemDs('hukou');
        const baseTypes = await dictService.dictItemDs('base');
        setOrgDs(orgds);
        setEducationalTypeDs(educationalTypes);
        setCertificateTypeDs(certificateTypes);
        setHukouTypeDs(hukouTypes);
        setBaseTypeDs(baseTypes);
    }

    const loadData = async (page?: ISearchPage, searchValue: any = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await rosterService.baseInfoPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    const exportData = async (searchValue: any = searchParam) => {
        const searchParams = {
            ...searchValue,
        }
        try {
            let result = await rosterService.export(searchParams);
            convertRes2Blob(result)
        } catch {
        }
    }

    const downloadTpl = async (searchValue: any = searchParam) => {
        const searchParams = {
            ...searchValue,
        }
        try {
            let result = await rosterService.downloadTpl(searchParams);
            convertRes2Blob(result)
        } catch {
        }
    }

    return {
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedData,
        pgCfg,
        initPgCfg,
        orgDs, educationalTypeDs, certificateTypeDs, hukouTypeDs, baseTypeDs,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedData,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData, loadDs,
        print, setPrint,
        exportData, downloadTpl,
        loading, setLoading,
    }
})